<template>
  <Questions v-if="$root.streamid && $root.password" />
  <Login v-else @do-login="doLogin" />
</template>

<script>
  
  import Questions from './components/Questions'
  import Login from './components/Login'

  export default {
    name: 'App',
    components: {
      Questions,
      Login
    },

    data: function() {
      return {
      }
    },

    methods: {
      doLogin(sid, pwd) {
        this.$root.streamid = sid;
        this.$root.password = pwd;
      }
    }
  }

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

  @media print {
    .body {
      overflow-x: visible !important;
      overflow: visible !important;
      height: auto !important;
    }
  }
</style>